import { OKTA_CLIENT_ID, OKTA_DOMAIN, OKTA_REDIRECT_URI } from 'utils/config.js';

const oktaConfig = {
  issuer: `${OKTA_DOMAIN}/oauth2/default`,
  clientId: OKTA_CLIENT_ID,
  redirectUri: OKTA_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
};

export default oktaConfig;
